import React from 'react';
import './JobListShortItem.less';
import classNames from 'classnames';

import Button from '../../../../components/envago/Button/Button';
import EnergyIcon from '../../../../components/envago/EnergyIcon/EnergyIcon';
import Icon from '../../../../components/envago/Icon/Icon';

import { JobType } from '../../../../redux/jobs/jobs.types';
import { resolveMeterType } from '../../../../helper/MeterHelper';
import { useTranslation } from 'react-i18next';
import { FieldVisibility } from '../../../../fieldVisibility/fieldVisibility';
import { jobRowCandidates } from '../../../../fieldVisibility/jobRowCandidates';

interface Props {
    job: JobType;
    onClick: () => void;
    className?: string;
    // Aus JobStatistics, nicht per Hook: eine Zeile je Auftrag einer Periode
    // baut sonst ein Store-Abo je Zeile. Konvention aus Issue #331, siehe
    // JobRowList.tsx.
    visibility: FieldVisibility;
}

const JobListShortItem = ({ job, onClick, className, visibility }: Props) => {
    const { t } = useTranslation();
    const meterType = resolveMeterType(job.meter);

    // Ein Platz, dieselbe Kandidatenliste. Ohne Rückfall bliebe eine Zeile aus
    // zwei Symbolen und einem Auge-Knopf.
    //
    // Die Automatik-Flaggen stehen hier auf true: diese Liste zeigt die Aufträge
    // EINER Periode, nicht die Gesamtliste, und hat keine Elternliste, die die
    // Flaggen berechnet. Der Objektschlüssel darf hier also als Kennung dienen,
    // sobald er gesetzt ist.
    const [label = ''] = jobRowCandidates({
        job,
        visibility,
        hasObjectKeyMultipleValues: true,
        hasLocationDescriptionMultipleValues: true,
        meterTypeLabel: t(`common.metertypes.${meterType}`),
    });

    return (
        <div role={'listitem'} className={classNames('flex items-center text-sm gap-x-4 border-b-2', className)}>
            <EnergyIcon className={'flex-0'} meterType={meterType} />
            {job.done ? (
                <Icon aria={{ 'aria-label': 'erledigt Icon' }} className={'h-5 text-green-500'} path={Icon.Path.mdiCheckCircle} />
            ) : (
                <Icon aria={{ 'aria-label': 'offen Icon' }} className={'h-5 text-gray-300'} path={Icon.Path.mdiCheckboxBlankCircleOutline} />
            )}
            <div className={'flex-1 '}>{label}</div>
            <Button aria={{role: "button"}} ghost iconButton onClick={onClick}>
                <Icon aria={{ 'aria-label': 'Auftrag öffnen' }} path={Icon.Path.mdiEye} />
            </Button>
        </div>
    );
};

export default JobListShortItem;
